import React, { SVGProps, useContext } from 'react'
import AppContext from '../../app/context'

const InfoIconCD = (props: SVGProps<SVGSVGElement>) => {
  const { state } = useContext(AppContext)

  if (!state.locationDesignConfig?.baseColors) return null

  return (
    <svg
      {...props}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="20"
        cy="20"
        r="19"
        stroke={state.locationDesignConfig.baseColors.secondary}
        strokeWidth="2"
      />
      <path
        d="M20 17L20 31"
        stroke={state.locationDesignConfig.baseColors.secondary}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle
        cx="20"
        cy="12"
        r="1"
        fill={state.locationDesignConfig.baseColors.secondary}
      />
    </svg>
  )
}
export default InfoIconCD
